/**
 * The frame every Apps page sits in: the inset beside the Apps sidebar, and
 * on phones (where the sidebar is a sheet) a slim strip that opens it.
 *
 * @module components/apps/AppsFrame
 */
import { LayoutGridIcon } from "lucide-react";
import type { ReactNode } from "react";

import { SidebarInset, SidebarTrigger } from "../ui/sidebar";

export function AppsFrame({ children }: { readonly children: ReactNode }) {
  return (
    <SidebarInset className="h-dvh min-h-0 overflow-hidden overscroll-y-none bg-background text-foreground isolate">
      <div className="flex min-h-0 min-w-0 flex-1 flex-col" data-apps-frame="">
        <header className="flex h-11 shrink-0 items-center gap-2 border-b border-border/60 px-3 text-[13px] md:hidden">
          <SidebarTrigger aria-label="Open Apps sidebar" />
          <LayoutGridIcon aria-hidden className="size-4 text-muted-foreground" />
          <span className="font-medium">Apps</span>
        </header>
        {children}
      </div>
    </SidebarInset>
  );
}
